module.exports = __webpack_public_path__ + "media/images/flags/flag_usa-aca6fc8dd7dba647725cbaef633a36cd.svg";